import { useEffect, useState } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'

/**
 * Báo có bản mới, và báo lần đầu app đã dùng được khi mất mạng.
 *
 * Không tự tải lại: người đang cầm máy tính tiền mà app tự nhảy giữa lúc gõ đơn là mất
 * nhịp và mất niềm tin. Hiện một dải nhỏ, họ bấm khi nào rảnh — thường là lúc vắng khách.
 */
export function UpdateBanner() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    offlineReady: [offlineReady, setOfflineReady],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisterError(error) {
      console.error('Không đăng ký được service worker', error)
    },
  })

  const [busy, setBusy] = useState(false)

  // Lời báo "dùng được khi mất mạng" chỉ cần thấy một lần, tự tắt sau vài giây.
  useEffect(() => {
    if (!offlineReady) return
    const t = setTimeout(() => setOfflineReady(false), 6000)
    return () => clearTimeout(t)
  }, [offlineReady, setOfflineReady])

  if (needRefresh) {
    return (
      <div className="sw-banner" role="status">
        <span className="sw-text">
          <b>Có bản mới</b>
          <small>Tải lại khi đang vắng khách</small>
        </span>
        <button
          type="button"
          className="sw-later"
          onClick={() => setNeedRefresh(false)}
        >
          Để sau
        </button>
        <button
          type="button"
          className="sw-now"
          disabled={busy}
          onClick={() => {
            setBusy(true)
            void updateServiceWorker(true)
          }}
        >
          {busy ? 'Đang tải…' : 'Tải lại'}
        </button>
      </div>
    )
  }

  if (offlineReady) {
    return (
      <div className="sw-banner is-ready" role="status">
        <span className="sw-text">
          <b>Đã sẵn sàng dùng khi mất mạng</b>
          <small>Mở app ra là bán được, không cần sóng</small>
        </span>
      </div>
    )
  }

  return null
}
